import * as React from "react"
import { useEffect } from "react"

import { ADMIN_ROUTES } from "@constants"
import {  resetAdminProductReview } from "./@signals"
import AdminProductReviewContent from "./Content"
import AdminProductReviewFilters from "./Filters"
import PageWrapper from "../../@PageWrapper"


export default function AdminProductReviewPage() {

	useEffect(() => {
		return () => resetAdminProductReview()
	}, [])

	return <PageWrapper
		head={`${ADMIN_ROUTES.ADMIN_REVIEW_TITLE}`}
		title={ADMIN_ROUTES.ADMIN_REVIEW_TITLE}
		actions={null}
		subtitle={ADMIN_ROUTES.ADMIN_REVIEW_SUBTITLE}
		filters={<AdminProductReviewFilters />}
	>
		<AdminProductReviewContent />
	</PageWrapper>
}